import { HomePage } from "../pages/HomePage/Loadable"
import { DeliveriesPage } from "app/pages/DeliveriesPage/Loadable"
import { RiderDashboard } from "app/pages/RiderDashboard/Loadable"
import { UsersPage } from "app/pages/UsersPage/Loadable"
// import { TrackingContent } from "app/pages/TrackingContent/Loadable"
// import { CustomerServicePage } from "app/pages/CustomerServicePage/Loadable"
import { DeliveriesHubsPage } from "app/pages/DeliveriesHubsPage/Loadable"
import { ReportsPage } from "app/pages/ReportsPage/Loadable"
import { MonitoringPage } from "app/pages/MonitoringPage/Loadable"
import { OpsMonitoringPage } from "app/pages/OpsMonitoringPage/Loadable"
import { EnrollDeliveriesPage } from "app/pages/EnrollDeliveriesPage/Loadable"
import { UploadPage } from "app/pages/UploadPage/Loadable"
import { UploadStatus } from "app/pages/UploadStatus/Loadable"
import { UploadLogsPage } from "app/pages/UploadLogsPage/Loadable"
import { CorrectionApprovalsPage } from "app/pages/CorrectionApprovalsPage/Loadable"
import { ComingSoonPage } from "app/pages/ComingSoonPage/Loadable"
import { LoginPage } from "app/pages/LoginPage/Loadable"
import { RiderPerformancePage } from "app/pages/RiderPerformancePage/Loadable"
import { RidersPage } from "app/pages/RidersPage/Loadable"
import { HubDashboardPage } from "app/pages/HubDashboardPage/Loadable"
import { HubDashboardWorkspace } from "app/pages/HubDashboardWorkspace/Loadable"
import { HubManagementPage } from "app/pages/HubManagementPage/Loadable"
import { SuperAdminDashboard } from "app/pages/SuperAdminDashboard/Loadable"
import { TransmittalPage } from "app/pages/TransmittalPage/Loadable"

const routes = [
  {
    path: "/",
    name: "Dashboard",
    icon: "fas fa-chart-line",
    component: <HomePage />,
    layout: "/admin",
    permissions: ["super_admin", "admin", "rider", "hub_admin"],
  },
  {
    path: "/deliveries",
    name: "Deliveries",
    icon: "ni ni-delivery-fast text-primary",
    component: <DeliveriesPage />,
    layout: "/admin",
    permissions: ["super_admin", "admin", "hub_admin"], //"rider",
  },
  // Enroll Deliveries — commented out (2026-08-07). Tracking
  // number generation moved to Upload Masterfile itself (createBulkDeliveries),
  // which made this page's original purpose unnecessary for now. Might be
  // needed again later for the raw-file-format transform on its own —
  // EnrollDeliveriesPage/index.tsx and enrollment.controller.js are untouched.
  // {
  //   path: "/enroll-deliveries",
  //   name: "Enroll Deliveries",
  //   icon: "ni ni-single-copy-04 text-primary",
  //   component: <EnrollDeliveriesPage />,
  //   layout: "/admin",
  //   permissions: ["super_admin", "admin"],
  // },
  {
    path: "/upload",
    name: "Upload Masterfile",
    icon: "ni ni-cloud-upload-96 text-primary",
    component: <UploadPage />,
    layout: "/admin",
    permissions: ["super_admin", "admin"],
  },
  {
    path: "/upload-status",
    name: "Update Status",
    icon: "ni ni-cloud-upload-96 text-primary",
    component: <UploadStatus />,
    layout: "/admin",
    permissions: ["super_admin", "admin"],
  },
  {
    path: "/upload-logs",
    name: "Upload Logs",
    icon: "ni ni-archive-2 text-primary",
    component: <UploadLogsPage />,
    layout: "/admin",
    permissions: ["super_admin", "admin"],
  },
  {
    path: "/correction-approvals",
    name: "Correction Approvals",
    icon: "ni ni-check-bold text-primary",
    component: <CorrectionApprovalsPage />,
    layout: "/admin",
    permissions: ["super_admin", "admin"],
  },
  {
    path: "/reports",
    name: "Reporting",
    icon: "ni ni-chart-bar-32 text-primary",
    component: <ReportsPage />,
    layout: "/admin",
    permissions: ["super_admin", "admin", "hub_admin"],
  },
  {
    path: "/return-to-main-office",
    name: "Return To Main Office",
    icon: "ni ni-box-2 text-primary",
    component: <ComingSoonPage />,
    layout: "/admin",
    permissions: ["super_admin", "admin"],
  },
  {
    path: "/hubs",
    name: "Delivery Hubs",
    icon: "ni ni-bullet-list-67 text-primary",
    component: <DeliveriesHubsPage />,
    layout: "/admin",
    permissions: ["super_admin", "admin"],
  },
  {
    path: "/users",
    name: "Users",
    icon: "ni ni-circle-08 text-primary",
    component: <UsersPage />,
    layout: "/admin",
    permissions: ["super_admin", "admin"],
  },
  // Rider Performance — commented out (2026-08-15). The
  // new Riders workspace below replaces it in the sidebar; this page still
  // reads from the same /riders/performance endpoint under the hood, so it's
  // left untouched (not deleted) in case it's needed again.
  // {
  //   path: "/rider-performance",
  //   name: "Rider Performance",
  //   icon: "fas fa-chart-bar text-primary",
  //   component: <RiderPerformancePage />,
  //   layout: "/admin",
  //   permissions: ["super_admin", "admin"],
  // },
  {
    path: "/riders",
    name: "Riders",
    icon: "fas fa-motorcycle text-primary",
    component: <RidersPage />,
    layout: "/admin",
    permissions: ["super_admin"],
  },
  // Old Hub Dashboard — commented out (2026-08-20), being
  // rebuilt from scratch as HubDashboardWorkspace below, starting with a
  // hub-scoped deliveries table and growing to sync with Transmittal/Riders.
  // HubDashboardPage/index.tsx is untouched — uncomment this block to bring
  // it back.
  // {
  //   path: "/hub-dashboard",
  //   name: "Hub Dashboard",
  //   icon: "fas fa-tachometer-alt text-primary",
  //   component: <HubDashboardPage />,
  //   layout: "/admin",
  //   permissions: ["super_admin", "admin", "hub_admin"],
  // },
  {
    path: "/hub-dashboard",
    name: "Hub Dashboard",
    icon: "fas fa-tachometer-alt text-primary",
    component: <HubDashboardWorkspace />,
    layout: "/admin",
    permissions: ["super_admin", "admin", "hub_admin"],
  },
  {
    path: "/hub-management",
    name: "Hub Management",
    icon: "fas fa-boxes-stacked text-primary",
    component: <HubManagementPage />,
    layout: "/admin",
    permissions: ["super_admin"],
  },
  // {
  //   path: "/trackingcontent",
  //   name: "Tracking Content",
  //   icon: "ni ni-circle-08 text-primary",
  //   component: <TrackingContent />,
  //   layout: "/admin",
  //   permissions: ["admin"],
  // },
  // TODO: Re-enable when Customer Service feature is fully tested
  // {
  //   path: "/customer-service",
  //   name: "Customer Service",
  //   icon: "ni ni-chat-round text-primary",
  //   component: <CustomerServicePage />,
  //   layout: "/admin",
  //   permissions: ["admin", "hub_admin"],
  // },
  // Old Monitoring page — commented out (2026-08-03), replaced
  // by Ops Monitoring below. MonitoringPage/index.tsx is untouched; uncomment
  // this block to bring the old sidebar entry back.
  // {
  //   path: "/monitoring",
  //   name: "Monitoring",
  //   icon: "ni ni-tv-2 text-primary",
  //   component: <MonitoringPage />,
  //   layout: "/admin",
  //   permissions: ["super_admin", "admin"],
  // },
  {
    path: "/ops-monitoring",
    name: "Ops Monitoring",
    icon: "ni ni-tv-2 text-primary",
    component: <OpsMonitoringPage />,
    layout: "/admin",
    permissions: ["super_admin", "admin", "hub_admin"],
  },
  {
    path: "/super-admin",
    name: "Super Admin",
    icon: "fas fa-project-diagram text-primary",
    component: <SuperAdminDashboard />,
    layout: "/admin",
    permissions: ["super_admin"],
  },
  {
    path: "/transmittal",
    name: "Transmittal",
    icon: "fas fa-file-invoice-dollar text-primary",
    component: <TransmittalPage />,
    layout: "/admin",
    // Reopened to admin/hub_admin (2026-10-12), Manila-only at first, widened
    // to also include Mandaluyong (2026-10-13) — matches the backend's
    // TRANSMITTAL_HUB_NAMES allowlist in transmittal.controller.js. Only
    // super_admin is exempt from restrictToHub (the one truly company-wide,
    // no-hub tier) — admin is deliberately NOT exempted, even though it's
    // company-wide elsewhere in this codebase, because an admin assigned to
    // an out-of-scope hub must not see this feature either (found live
    // 2026-10-12: a Mandaluyong-assigned admin could see the nav link before
    // this was tightened, back when Mandaluyong itself was still out of
    // scope). Not a full security boundary by itself — the backend's
    // enforceDataAccess still treats `admin` as high-privilege and does NOT
    // hub-scope it at the API level, so this nav gate only stops discovery
    // via the UI, not a direct API call with a valid admin token.
    // Deliberately left as-is for now — see
    // project_speedworks_transmittal_todo.md item 9 for the deferred fix.
    permissions: ["super_admin", "admin", "hub_admin"],
    restrictToHub: ["Manila", "Mandaluyong"],
  },
  {
    path: "/rider-dashboard",
    name: "My Deliveries",
    icon: "fas fa-box",
    component: <RiderDashboard />,
    layout: "/admin",
    permissions: ["rider"],
  },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <LoginPage />,
    layout: "/auth",
  },
]

export default routes
